// import logo from './logo.svg';
import './App.css';
// import Header from './component/Header'
import Main from './component/Main'


function App() {
  return (
    <div>
      {/* <ShepherdTour steps={newSteps} tourOptions={tourOptions}>
        <TourMethods>
          {tourContext => <Start startTour={tourContext} />}
        </TourMethods> */}
        <Main />
      {/* </ShepherdTour> */}
    </div>
  );
}

export default App;
